module.exports = __webpack_public_path__ + "static/media/linux-plain.572e62e9.svg";